export enum EStatusCode {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export const StatusMapping: Record<string, EStatusCode> = {
    y: EStatusCode.ACTIVE,
    true: EStatusCode.ACTIVE,
    Y: EStatusCode.ACTIVE,

    n: EStatusCode.INACTIVE,
    false: EStatusCode.INACTIVE,
    undefined: EStatusCode.INACTIVE,
    N: EStatusCode.INACTIVE,
};

export const StatusTitle:Record<EStatusCode, string> = {
    [EStatusCode.ACTIVE]: 'Активен',
    [EStatusCode.INACTIVE]: 'Неактивен',
};

export const StatusColor: Record<EStatusCode, string> = {
    [EStatusCode.ACTIVE]: '#43A047',
    [EStatusCode.INACTIVE]: '#959DAC',
};
